import * as React from 'react';
export const IcHockey = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 15a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm1.75-9.2a1.472 1.472 0 10-2.44-1.65L15.16 6.6l2.44 1.65 1.65-2.45zm-5.2 2.44l-6.31 9.37a1 1 0 01-1.36.27 1 1 0 01-.27-1.37l.83-1.22a1.48 1.48 0 00-2.45-1.65l-.82 1.22a3.931 3.931 0 106.51 4.41l6.31-9.38-2.44-1.65z'
      fill='currentColor'
    />
  </svg>
);
